<mat-toolbar md-scroll-shrink>
  <button
    mat-icon-button
    *ngIf="sidenav.mode === 'over'"
    (click)="sidenav.toggle()"
  >
    <mat-icon *ngIf="!sidenav.opened"> menu </mat-icon>
    <mat-icon *ngIf="sidenav.opened"> close </mat-icon>
  </button>
  <div class="tile-icon">
    <img class="" src="../assets/icons/menu_logo.png" alt="HondaLink" />
  </div>

  <span class="spacer"></span>
  <div class="top-nav-bar" *ngIf="sidenav.mode === 'side'">
    <app-top-nav></app-top-nav>
  </div>
</mat-toolbar>

<div class="divider"></div>

<div *ngIf="sidenav.mode === 'over' && sidenav.opened">
  <app-top-nav></app-top-nav>
  <div class="divider"></div>
</div>

<mat-sidenav-container>
  <mat-sidenav #sidenav="matSidenav"> </mat-sidenav>
  <mat-sidenav-content>
    <div class="content">
      <router-outlet></router-outlet>
      <!-- <app-reset-pin-component></app-reset-pin-component> -->
      <!-- <app-reset-pin-success></app-reset-pin-success> -->
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
